import { ButtonSizeType, ButtonVariantType, } from '../../../../../designSystem/reloaded/commons/components/button/variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    parentContainer: {
        display: 'flex',
        flex_wrap: 'wrap',
        position: 'relative',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    listContainer: {
        display: 'flex',
        flex_wrap: 'wrap',
        margin: '0',
        padding: '0',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
    },
    inerActionLinkContainer: {
        visibility: 'hidden',
    },
    actionLinkContainer: {
        position: 'absolute',
    },
    chipContainer: {
        display: 'inline-block',
        cursor: 'default',
    },
    // style for the focus state of the button that wraps the Chip
    chipButtonWrapper: {
        border_radius: FOUNDATIONS.radius_150,
    },
    actionLink: {
        variant: ButtonVariantType.SECONDARY,
        size: ButtonSizeType.EXTRA_SMALL,
    },
    transitionDuration: FOUNDATIONS.duration_200,
});
//# sourceMappingURL=commonStyles.js.map